export const PROJECT_NEXT = {
  idea: ["monitoring", "researching", "archived"],
  monitoring: ["researching", "archived"],
  researching: ["verification", "monitoring", "archived"],
  verification: ["writing", "researching", "archived"],
  writing: ["editorial_review", "verification", "archived"],
  editorial_review: ["published", "writing", "archived"],
  published: ["archived"],
  archived: [],
};

export const CLAIM_NEXT = {
  received: ["researching", "unable_to_verify", "archived"],
  researching: ["evidence_review", "unable_to_verify", "archived"],
  evidence_review: ["drafting", "researching", "unable_to_verify", "archived"],
  drafting: ["editorial_review", "evidence_review", "archived"],
  editorial_review: ["ready_to_publish", "drafting", "archived"],
  ready_to_publish: ["published", "editorial_review", "archived"],
  published: ["archived"],
  unable_to_verify: ["researching", "archived"],
  archived: [],
};

export const CONTENT_NEXT = {
  idea: ["draft", "archived"],
  draft: ["verification", "archived"],
  verification: ["editorial_review", "draft", "archived"],
  editorial_review: ["ready_to_publish", "verification", "draft", "rejected", "archived"],
  ready_to_publish: ["scheduled", "published", "editorial_review", "archived"],
  scheduled: ["published", "ready_to_publish", "archived"],
  published: ["updated", "unpublished", "archived"],
  updated: ["published", "unpublished", "archived"],
  unpublished: ["published", "archived"],
  rejected: ["draft", "archived"],
  archived: ["draft"],
};

export const VERDICTS = ["true", "mostly_true", "mixed", "misleading", "unproven", "false"];
